import "./ColaboradorSign.css";
import axios from "axios";
import React, { useContext, useState } from "react";
import LoadingAction from "../../../themes/LoadingAction/LoadingAction";
import Auth from "../AdminAuth/Auth";
import * as links from "../../../utils/links";
import { SERVIDOR_URL } from "../../../utils/constants";
import signinUpgrade from "../../../assets/images/posto.jpg";
import vSignin from '../../../assets/images/v5_imagem.jpg';
import { AuthContext } from "../../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { NotificationContainer } from "react-notifications";


const initialDataSignIn = {
  cpf: "",
  password: "",
};

const initErrorField = {
  cpf: undefined,
  password: undefined,
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const ColaboradorSignIn = (props) => {
  const { setDataUser, loading, notiMessage, setNotiMessage } =
    useContext<any>(AuthContext);
  let navigate = useNavigate();

  const [dataAuth, setDataSingUp] = useState<any>({ ...initialDataSignIn });
  const [error, setError] = useState<any>(null);
  const [success, setSuccess] = useState<any>(false);
  const [errorField, setErrorField] = useState<any>({ ...initErrorField });
  const [isLoading, setIsLoading] = useState<any>(false);

  const onsubmit = () => {
    let dataErrorField: any = {};
    if (dataAuth.cpf.trim() === "" || dataAuth.cpf.length < 6) {
      dataErrorField = {
        ...dataErrorField,
        cpf: "CPF obrigatório e deve conter 11 dígitos",
      };
    }
    if (dataAuth.password.trim() === "") {
      dataErrorField = {
        ...dataErrorField,
        password: "Senha obrigatória",
      };
    } else if (dataAuth.password.trim().length < 6) {
      dataErrorField = {
        ...dataErrorField,
        password: "Senha tem que ter no mínimo 6 dígitos.",
      };
    }

    setSuccess(false);
    if (Object.keys(dataErrorField).length === 0) {
      setIsLoading(true);
      setError(null);
      axios
        .post(`${SERVIDOR_URL}/login-colaborador`, {
          senha: dataAuth.password,
          cpf: dataAuth.cpf,
        })

        .then((res) => {
          if (res.status === 200) {
            const responseData = res.data ?? {};
            const collaborator =
              responseData.colaborador ?? responseData.user ?? responseData;
            const normalizedUser = {
              ...responseData,
              ...collaborator,
              token: responseData.token ?? collaborator?.token,
              key: collaborator?.key ?? responseData.key ?? "COLABORADOR",
            };

            if (!normalizedUser.id || !normalizedUser.token) {
              throw new Error("Resposta de login do colaborador incompleta.");
            }

            setIsLoading(false);
            setSuccess(true);
            setDataSingUp({
              ...initialDataSignIn,
            });
            setDataUser(normalizedUser);
            navigate(links.DASHBOARD_COLABORADOR);
          } else {
            throw new Error();
          }
        })
        .catch((err) => {
          setIsLoading(false);
          if (err.response?.status === 500) {
            setError(
              'Usuário já existe, <a target="_blank" href=' +
                links.FORGOTPASSWORD +
                ">esqueceu sua senha<a/>?"
            );
          } else {
            setError(
              err.message === "Resposta de login do colaborador incompleta."
                ? "O servidor retornou uma sessão incompleta. Tente entrar novamente."
                : "Erro, algo deu errado " + (err.response?.data?.error ?? "")
            );
          }
        });
    } else {
      setErrorField((prev) => {
        return {
          ...prev,
          ...dataErrorField,
        };
      });
    }
  };

  return (
    <>
      <NotificationContainer />
      {isLoading && <LoadingAction />}
      <Auth
        authTitle={"Login Colaborador"}
        authDescription={"Preencha com CPF e senha."}
        authFields={[
          {
            label: "CPF",
            placeholder: "Digite os 6 primeiros diígitos do CPF",
            name: "cpf",
            value: dataAuth?.cpf ?? "",
            type: "text",
            setField: (value) => {
              setDataSingUp((prev) => ({
                ...prev,
                cpf: value,
              }));
              setErrorField((prev) => ({
                ...prev,
                cpf: undefined,
              }));
            },
            error: errorField?.cpf ?? "",
          },
          {
            label: "Senha",
            placeholder: "Digite sua senha",
            name: "password",
            value: dataAuth?.password ?? "",
            type: "password",
            setField: (value) => {
              setDataSingUp((prev) => ({
                ...prev,
                password: value,
              }));
              setErrorField((prev) => ({
                ...prev,
                password: undefined,
              }));
            },
            error: errorField?.password ?? "",
          },
        ]}
        authSubmit={"Entrar"}
        // textImage={"Painel Colaborador"}
        authImage={signinUpgrade}
        onsubmit={() => {
          onsubmit();
        }}
        successMessage={success ? "Usuário cadastrado com sucesso!" : ""}
        errorMessage={error ?? ""}
        isSignIn={true}
      />
    </>
  );
};

export default ColaboradorSignIn;
